import { createReducer, MetaReducer, on } from '@ngrx/store';
import LicenseActions from './license.action-types';

export const licenseFeatureKey = 'license';

export interface LicenseState {
    active: boolean;
    loading: boolean;
    usedLicenses: number;
    totalLicenses: number;
}

export const initialLicenseState: LicenseState = {
    active: false,
    loading: false,
    usedLicenses: 0,
    totalLicenses: 0
};

export const metaReducers: MetaReducer<LicenseState>[] = [];

export const licenseReducer = createReducer(
    initialLicenseState,

    on(LicenseActions.activateLicenseRequest, (state, action) => {
        return { ...state, loading: true };
    }),
    on(LicenseActions.setActiveLicense, (state, action) => {
        return {
            ...state,
            loading: false,
            active: action.licenseResponse.active
        };
    }),
    on(LicenseActions.setLicenseUsage, (state, action) => {
        return {
            ...state,
            usedLicenses: action.licenseUsage.usedLicenses,
            totalLicenses: action.licenseUsage.totalLicenses
        };
    })
);
